<div mat-dialog-content>

    <h3 mat-dialog-title align="left"><strong>Edit My Loan</strong></h3>

    <ng-container *ngIf="IsReady">
        <div *ngIf="LgvClientSvc.SelectedProperty$ | async as property">
            <b>{{property?.propertyInfo?.address}} | {{property?.propertyInfo?.city}}, {{property?.propertyInfo?.state}} {{property?.propertyInfo?.zip}}</b>
        </div>
    </ng-container>

    <div class="container">

        <form [formGroup]="LoanForm" *ngIf="IsReady">

            <div class="row">
                <!--<mat-form-field appearance="outline" floatLabel="always">
              <mat-label>Purchase Price</mat-label>
              <input type="number" matInput formControlName="purchasePrice">
          </mat-form-field>-->

                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Interest Rate</mat-label>
                    <input type="number" matInput formControlName="interestRate">
                </mat-form-field>


                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Current Balance</mat-label>
                    <input type="number" matInput formControlName="estimatedBalance">
                </mat-form-field>

                <mat-form-field appearance="outline" floatLabel="always" *ngIf="isFirstLoan">
                    <mat-label>Closing Date</mat-label>
                    <input matInput [matDatepicker]="picker3" formControlName="closingDate">
                    <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                    <mat-datepicker #picker3></mat-datepicker>
                </mat-form-field>

                <mat-form-field appearance="outline" floatLabel="always" *ngIf="isFirstLoan">
                    <mat-label>Original Loan Amount</mat-label>
                    <input type="number" matInput formControlName="originalLoanAmount">
                </mat-form-field>

                <mat-form-field appearance="outline" floatLabel="always" *ngIf="isFirstLoan">
                    <mat-label>Loan Term</mat-label>
                    <input type="number" matInput formControlName="loanTerm">
                </mat-form-field>

                <mat-form-field appearance="outline" floatLabel="always" *ngIf="isFirstLoan">
                    <mat-label>Loan Type</mat-label>
                    <mat-select formControlName="loanTypeId">
                        <mat-option *ngFor="let item of loanTypeList$ | async" [value]="item.id">
                            {{item.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </form>


    </div>
    <div class="Vert-30"></div>
</div>

<div mat-dialog-actions align="end">
    <button mat-button (click)="onNoClick()">Cancel</button>
    <button type="button" class="btn btn-secondary formBtn" (click)="OnUpdateLoan()"
        [disabled]="!LoanForm.valid">Update</button>
</div>

<lgv-loading-indicator *ngIf="!IsReady"></lgv-loading-indicator>
